<app-validation-warning-dialog
    [failed]="failedCount"
    [total]="jobIds.length"
    [isOpen]="isValidationModalOpen"
    (confirm)="onProceed()"
></app-validation-warning-dialog>
<div class="ui basic segment" [class.loading]="isSaving">
    <app-header title="Create Employer Account" [back]="true"></app-header>
    <app-job-posting-card [(isIndeedJobSyncEnabled)]="isIndeedJobSyncEnabled"></app-job-posting-card>
    @if (isIndeedJobSyncEnabled) {
        <div class="ui segment">
            <app-segment-header title="Account Information"></app-segment-header>
            <p>If your company does not have an Indeed account, you can create one below.</p>
            <app-indeed-employer #employerForm [employer]="employer"></app-indeed-employer>
            <!--        Sync Jobs-->
            <div class="app-grid">
                <mat-checkbox
                    [(ngModel)]="integrationIndeed.syncJobs"
                    name="sync"
                    type="checkbox"
                    class="columns-4 small-columns-12"
                >
                    Post all active jobs to Indeed when integration is complete.
                </mat-checkbox>
            </div>
        </div>
        <app-quick-apply-card [(integrationIndeed)]="integrationIndeed"></app-quick-apply-card>
    }
    <div class="flex width-full justify-end">
        <ui-button type="primary" [disabled]="!canSave" (click)="submit()"
            >Next <mat-icon svgIcon="chevronRight"></mat-icon
        ></ui-button>
    </div>
</div>
